(() => {
  if(customElements.get('sunpura-market-gift-badge')) return;
  customElements.define('sunpura-market-gift-badge',class extends HTMLElement{
    connectedCallback(){
      this.viewer=this.closest('slider-component');
      this.list=this.viewer?.querySelector('[id^="Slider-Gallery-"]');
      if(!this.list) return;
      this.sync=()=>{const first=this.list.querySelector('[data-media-id]');const active=this.list.querySelector('.is-active');this.hidden=!!active&&active!==first;};
      this.onSlide=event=>{const first=this.list.querySelector('[data-media-id]');this.hidden=event.detail?.currentElement!==first;};
      this.viewer.addEventListener('slideChanged',this.onSlide);
      this.observer=new MutationObserver(this.sync);
      this.observer.observe(this.list,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
      this.sync();
    }
    disconnectedCallback(){this.observer?.disconnect();this.viewer?.removeEventListener('slideChanged',this.onSlide);}
  });
})();
